var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoreAvatarPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "180 214 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M197.21,217.17h-15.31c-.09,0-.17.04-.24.1-.06.06-.1.15-.1.24v13.31c0,.09.04.17.1.24.06.06.15.1.24.1h15.31c.09,0,.18-.04.24-.1.06-.06.1-.15.1-.24v-13.31c0-.09-.04-.18-.1-.24-.06-.06-.15-.1-.24-.1h0ZM181.89,215.82h15.31c.46,0,.89.19,1.19.49.31.31.49.73.49,1.19v13.31c0,.46-.19.88-.49,1.19-.3.31-.73.49-1.19.49h-15.31c-.46,0-.88-.19-1.19-.49-.31-.31-.49-.73-.49-1.19v-13.31c0-.47.19-.89.49-1.19.31-.31.73-.49,1.19-.49h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M182.64,230.42c-.2,0-.36-.16-.36-.36v-.31c0-.32,0-.39.15-.56l4.68-5.79c.1-.13.25-.2.42-.21.16,0,.32.06.43.18l2.83,3,1.27-1.08.03-.03c.1-.08.23-.12.36-.11.13,0,.25.06.35.15l.03.03,3.92,4.09c.08.09.08.07.08.21v.42c0,.2-.16.36-.35.36h-13.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M192.12,218.94c.39-.39.93-.63,1.52-.63s1.13.24,1.52.63c.39.39.63.93.63,1.52s-.24,1.13-.63,1.52c-.39.39-.93.63-1.52.63s-1.13-.24-1.52-.63c-.39-.39-.63-.93-.63-1.52s.24-1.13.63-1.52h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreAvatarPlaceholder);
export default __webpack_public_path__ + "static/media/store-avatar-placeholder.98edc390bb62472dffa9061fdc00bd5c.svg";
export { ForwardRef as ReactComponent };